import { createContext } from "react";

const ReporteContext = createContext();

export default ReporteContext;
